<div class="page">
  <div class='notification-heading'>
    <h1 class="page__heading">All Notifications</h1>
    <button #markAllBtn kendoButton fillMode="outline" [svgIcon]="squareCheck" [themeColor]="'primary'"
      class="k-justify-content-right" *ngIf="allNotifications?.length" (click)="showAllReadWarning()"
      aria-label="Mark All as Done or Read">Mark All as
      Done/Read</button>
  </div>
  <kendo-grid [data]="gridView" [navigable]="false" [hideHeader]="true" [autoSize]="true" [pageSize]="pageSize" [skip]="skip"
    [pageable]="{ buttonCount: 6, type: 'numeric', pageSizes: true }" (pageChange)="onPageChange($event)">
    <ng-template kendoGridToolbarTemplate position="top">
      <div class="toolbar-wrapper">
        <kendo-label [for]="searchBox" labelCssClass="k-sr-only" text="text ">
          </kendo-label>
          <kendo-textbox #searchBox placeholder="Search Student ID" aria-label="Search Student ID" style="width: 100%;"
          (valueChange)="handleNotificationSearch($event)">
          <ng-template kendoTextBoxPrefixTemplate>
            <kendo-svg-icon [icon]="searchIcon" size="medium" themeColor="primary"></kendo-svg-icon>
          </ng-template>
        </kendo-textbox>
      </div>
    </ng-template>
    <kendo-grid-column [style]="{padding: '0'}">
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-notification-content [content]="[dataItem]"></app-notification-content>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>